<div class="mt-5 d-flex justify-content-center">
    <div>
        <img src="images/logo-dark@2x.png" class="mb-4 logo" alt="Bitwarden">
        <p class="text-center">
            <i class="fa fa-spinner fa-spin fa-2x text-muted" title="{{'loading' | i18n}}"></i>
        </p>
    </div>
</div>
